<div class="page-container">
  <div class="pricing-content scrollable-content">
    <div class="pricing-header">
      <h1>{{ 'pricing.title' | translate }}</h1>
      <p class="tagline">{{ 'pricing.tagline' | translate }}</p>
    </div>

    @if (state() === 'loading') {
      <div class="loading-container flex flex-column flex-align-center p-lg">
        <app-spinner />
      </div>
    }

    @if (state() === 'error') {
      <div class="error-container p-lg" data-testid="pricing-error">
        <p>{{ 'pricing.loadError' | translate }}</p>
      </div>
    }

    @if (state() === 'loaded') {
      <div class="plans-grid">
        @for (plan of plans(); track plan.id) {
          <app-card class="plan-card" [attr.data-testid]="'plan-card-' + plan.id">
            <div class="plan-card-content flex flex-column gap-md p-lg">
              <h2>{{ plan.name }}</h2>

              @if (plan.selfServe) {
                <div class="plan-price">
                  <span class="price-amount">{{ formatPrice(plan.priceMonthlyCents) }}</span>
                  <span class="price-period">{{ 'pricing.perMonth' | translate }}</span>
                </div>
              } @else {
                <div class="plan-price">
                  <span class="price-amount">{{ 'pricing.contactSales' | translate }}</span>
                </div>
              }

              <ul class="plan-limits">
                <li>
                  {{ plan.assetLimit === null ? ('pricing.unlimitedAssets' | translate) : plan.assetLimit + ' ' + ('pricing.assets' | translate) }}
                </li>
                <li>
                  {{ plan.customFormLimit === null ? ('pricing.unlimitedForms' | translate) : plan.customFormLimit + ' ' + ('pricing.customForms' | translate) }}
                </li>
              </ul>

              @if (plan.selfServe) {
                <app-button variant="filled" (click)="selectPlan(plan)" [attr.data-testid]="'plan-select-' + plan.id">
                  {{ 'pricing.getStarted' | translate }}
                </app-button>
              } @else {
                <a href="mailto:sales@checkpoint.com" class="btn-contact-sales" data-testid="plan-contact-sales">
                  {{ 'pricing.contactUs' | translate }}
                </a>
              }
            </div>
          </app-card>
        }
      </div>

      @if (formPacks().length > 0) {
        <div class="form-packs-section">
          <h2>{{ 'pricing.formPacks.title' | translate }}</h2>
          <p class="tagline">{{ 'pricing.formPacks.description' | translate }}</p>
          <div class="form-packs-grid">
            @for (pack of formPacks(); track pack.id) {
              <app-card class="form-pack-card">
                <div class="flex flex-column gap-sm p-md">
                  <span class="pack-count">{{ pack.formCount }} {{ 'pricing.customForms' | translate }}</span>
                  <span class="pack-price">{{ formatPrice(pack.priceCents) }}</span>
                </div>
              </app-card>
            }
          </div>
        </div>
      }
    }
  </div>
</div>
